import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ClipboardList } from 'lucide-react';

export const Route = createFileRoute('/admin-console/platform-content/obligations')({
    staticData: {
        permissions: ['admin_content:read'],
        breadcrumb: {
            title: 'Obligations',
            inactive: true,
        },
        ui: {
            icon: ClipboardList,
            menuDescription: 'Library, controls, and configuration',
        },
    },
    component: Outlet,
});
